var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#003f97",
    className: "st0",
    d: "M64.281,225.656H9.031c-4.984,0-9.031,4.047-9.031,9.031v173.219c0,4.984,4.047,9.031,9.031,9.031h55.25 c5,0,9.047-4.047,9.047-9.031V234.688C73.328,229.703,69.281,225.656,64.281,225.656z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003f97",
    className: "st0",
    d: "M469.719,195.422H369.297h-24.453h-77.813c-5.891,0-11.422-2.875-14.813-7.703 c-3.375-4.828-4.188-11-2.172-16.547l20.625-56.719c2.016-5.531,1.203-11.703-2.172-16.531c-3.391-4.828-8.922-7.703-14.813-7.703 h-2.719c-18.031,0-34.906,8.969-44.984,23.938L110.516,243.25v132.297l85.281,32.688c5.188,1.594,11.563,3.188,16.609,3.984 l75.813,9.563c23.344,0,44.078-14.938,51.469-37.078l37.75-114.609c1.219-3.688,4.688-6.203,8.594-6.203h91.734 c27.031,0,34.234-15.328,34.234-34.234S488.625,195.422,469.719,195.422z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.11293e60249ae47b66ffd16391cf3864.svg";
export { ForwardRef as ReactComponent };